import { useEffect } from "react";

import { FiltersContainer } from "../../filters/ui/FiltersContainer";
import type { AlertViewMode } from "../../tabs/viewModeConfig";

import { NewsType } from "./NewsType";
import { Search } from "./Search";
import { Topic } from "./topic/Topic";
import { useNewsAlertsFilterStore } from "./useNewsAlertsFilterStore";

type NewsAlertsFiltersProps = {
    viewMode: AlertViewMode;
};

export const NewsAlertsFilters = ({ viewMode }: NewsAlertsFiltersProps) => {
    const reset = useNewsAlertsFilterStore((state) => state.reset);

    useEffect(() => reset, [reset]);

    return (
        <FiltersContainer>
            <Topic />
            {viewMode === "feed" ? (
                <>
                    <NewsType />
                    <Search />
                </>
            ) : null}
        </FiltersContainer>
    );
};
